<template>
    <div class="d-flex align-center justify-center">
        <j-user-form class="wi-100" @focus="errorsPresents = false" @validate="register" :control="true" :usage="['firstname','lastname','email','phone','password','confirmPassword','optin']" :submitWord="'Inscription'" ></j-user-form>
        <div class="justify-center">
            <v-alert v-if='errorsPresents' class="red lighten-2 white_">{{errorMessage}}</v-alert>
        </div>
    </div>
</template>

<style lang="scss">
    
</style>

<script>
import { REGISTER_REQUEST } from "@/assets/jobtimise-common/store/actions/register"

export default {
    name: 'register-form',
    data: function(){
        return {
            errorsPresents:false,
            errorMessage:"Une erreur est survenue, veuillez réessayer."
        }
    },
    components:{
    },
    methods: {
        register: function (user) {
            this.$store.dispatch(REGISTER_REQUEST, user).then(() => {
                this.$emit('registered')
            }).catch(err=>{
                this.errorMessage = err.data.message || "Une erreur est survenue, veuillez réessayer."
                this.errorsPresents = true
            });
        }
    }
}
</script>

<style>

</style>